import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    top: theme.spacing(10),
    // bottom: theme.spacing(6),
    // bottom: theme.spacing(6),
    right: theme.spacing(6),
  },
}));

export default function FloatingActionButtons({ onClick }) {
  const classes = useStyles();

  return (
    <Fab
      color="primary"
      aria-label="add"
      className={classes.fab}
      style={{ zIndex: 1000, outline: "none" ,backgroundColor:"#2ba9cd"}}
      onClick={onClick}
    >
      <AddIcon />
    </Fab>
  );
}
